import { render, staticRenderFns } from "./WorkPermitView.vue?vue&type=template&id=22cae8cd&scoped=true&"
import script from "./WorkPermitView.vue?vue&type=script&lang=js&"
export * from "./WorkPermitView.vue?vue&type=script&lang=js&"
import style0 from "./WorkPermitView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WorkPermitView.vue?vue&type=style&index=1&id=22cae8cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cae8cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22cae8cd')) {
      api.createRecord('22cae8cd', component.options)
    } else {
      api.reload('22cae8cd', component.options)
    }
    module.hot.accept("./WorkPermitView.vue?vue&type=template&id=22cae8cd&scoped=true&", function () {
      api.rerender('22cae8cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboards/WorkPermitView.vue"
export default component.exports